import React, { createContext, useContext, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import './ConfirmationPopup.css';
import Button from './Buttons';

// Create the Confirmation Context
const ConfirmationContext = createContext();

// Hook to use Confirmation Context
export const useConfirmation = () => {
    return useContext(ConfirmationContext);
};

// Confirmation Provider
export const ConfirmationProvider = ({ children }) => {
    const [confirmation, setConfirmation] = useState({
        isOpen: false,
        message: '',
        onConfirm: null,
    });

    // Show confirmation popup
    const showConfirmation = (message, onConfirm) => {
        setConfirmation({ isOpen: true, message, onConfirm });
    };

    // Handle confirm action
    const handleConfirm = () => {
        if (confirmation.onConfirm) {
            confirmation.onConfirm(); // Execute the passed function
        }
        closeConfirmation();
    };

    // Handle cancel action
    const closeConfirmation = () => {
        setConfirmation({ isOpen: false, message: '', onConfirm: null });
    };

    return (
        <ConfirmationContext.Provider value={{ showConfirmation }}>
            {children}
            <AnimatePresence>
                {confirmation.isOpen && (
                    <motion.div
                        className="confirmation-popup-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <motion.div
                            className="confirmation-popup"
                            initial={{ scale: 0.8 }}
                            animate={{ scale: 1 }}
                            exit={{ scale: 0.8 }}
                            transition={{ duration: 0.3 }}
                        >
                            <strong>Sure about this aciton?</strong>
                            <span>{confirmation.message}</span>
                            <div className="confirmation-popup-buttons">
                                <Button variant='primary' size='large' onClick={handleConfirm}>
                                    Confirm
                                </Button>
                                <Button variant='danger' size='large' onClick={closeConfirmation}>
                                    Cancel
                                </Button>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </ConfirmationContext.Provider>
    );
};